import { useTranslation } from 'react-i18next';
import { Vulnerability } from '../../../../../types';
import { regexIncludeH1H2Tag } from '../../../../../util/regex/html';
import { DefaultCard } from '../../../../DefaultCard';
import { HtmlBlockWithStyles } from '../../../../HtmlBlock';

/**
 * Component that renders the "Executive Summary" section (arbitrary html).
 */
export const ExecutiveSummaryView = ({
  description,
}: {
  description?: Vulnerability['description'];
}) => {
  // Executive summaries are only used in rare situations, so we don't want to
  // show any loaders or indicators that this card is here until we have data.
  const [t] = useTranslation('vulnerability', { useSuspense: false });
  if (!description) {
    return null;
  }

  const header = t('executiveSummary.Executive Summary', {
    defaultValue: 'Executive Summary',
    ns: 'vulnerability',
  });

  // disable the title when secrel wants to use this as a freeform text area
  const hideHeader =
    regexIncludeH1H2Tag.test(description) || description.includes(header);

  return (
    <DefaultCard header={header} hideHeader={hideHeader} id='executiveSummary'>
      <HtmlBlockWithStyles>{description}</HtmlBlockWithStyles>
    </DefaultCard>
  );
};
